module.exports = __webpack_public_path__ + "img/09-villas.5c30f525.jpg";